import Datasource from "api/lib/data/Datasources";
import * as React from "react";
import { NavLink } from "react-router-dom";
import { Menu } from "semantic-ui-react";
import * as routes from "src/constants/routes";
import { Base, IBaseProps, IBaseState } from "../Common/Base";

export interface IDatasourcesNavProps extends IBaseProps {
  orgId: string;
  history: any;
}

export interface IDatasourcesNavState extends IBaseState {
  datasources: any[];
}

export default class DatasourcesNav extends Base<
  IDatasourcesNavProps,
  IDatasourcesNavState
> {
  private static INITIAL_STATE = {
    datasources: [],
    listeners: [],
  };
  constructor(props: IDatasourcesNavProps) {
    super(props);

    this.state = { ...DatasourcesNav.INITIAL_STATE };
  }

  public render() {
    const { datasources } = this.state;
    const { orgId } = this.props;

    return (
      <React.Fragment>
        <Menu.Header>Datasources</Menu.Header>
        <Menu.Menu className="list-menu">
          {datasources.map((option: any) => (
            <Menu.Item
              as={NavLink}
              activeClassName="active"
              to={routes.NEW_DATASOURCE(orgId, option.id)}
              key={option.id}
              name={option.name}
            />
          ))}
        </Menu.Menu>
        <Menu.Menu>
          <Menu.Item
            as={NavLink}
            activeClassName="active"
            to={routes.DATASOURCES(orgId)}
            name="Show All"
          />
          <Menu.Item
            as={NavLink}
            activeClassName="active"
            to={routes.NEW_DATASOURCE(orgId, routes.NEW)}
            name="New"
          />
        </Menu.Menu>
      </React.Fragment>
    );
  }

  public componentDidMount = () => {
    this.getData();
  };

  public getData = () => {
    const { orgId, authUser } = this.props;
    const datasources = new Datasource(orgId);
    this.getList(datasources, authUser.uid, (data: any[]) => {
      this.setState({ datasources: data });
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/Navigation/DatasourcesNav.tsx